module.exports = __webpack_public_path__ + "img/9.b7f48371.jpeg";